export const content = {
  bannerText: '10% Group discount applied',
}
